import { useState } from "react";
import {
    Datagrid,
    ReferenceManyField,
    TextField,
    useRecordContext,
    useTranslate,
    FunctionField,
} from "react-admin";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export const RentalsWithFilterReference = ({ target }) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const [stateFilter, setStateFilter] = useState("");

    if (!record) return null;

    return (
        <Box>
            <RentalStateFilter value={stateFilter} onChange={setStateFilter} />
            <ReferenceManyField
                reference="rentalItems"
                target={target}
                pagination={<DefaultPagination />}
                sort={{ field: "id", order: "DESC" }}
                filter={{
                    _embed: "rental",
                    ...(stateFilter && { state: stateFilter }),
                }}
                perPage={50}
            >
                <Datagrid
                    bulkActionButtons={false}
                    rowClick={(id, resource, record) => {
                        return record.rental.type === 'repair_order' ? `/repairOrders/${record.rental.id}/show` : `/rentals/${record.rental.id}/show`;
                    }}
                >
                    <TextField source="rental.name" label="equip.rental" />
                    <FunctionField
                        label="equip.type"
                        render={(record) =>
                            translate(record.rental.type === 'repair_order' ? 'equip.repairOrder' : `equip.${record.rental.type}`)
                        }
                    />
                    <FunctionField label="equip.sku" render={(record) => record.sku?.labelNumber} />
                    <RaDateField source="createdAt" label="equip.date" />
                    <RaDateField source="plannedReturnDate" label="equip.plannedReturnDate" />
                    <TextField source="quantity" label="equip.quantity" />
                    <TextField source="state" label="equip.state" />
                </Datagrid>
            </ReferenceManyField>
        </Box>
    );
};

const RentalStateFilter = ({ value, onChange }) => {
    const translate = useTranslate();

    const stateChoices = [
        { id: "", name: "equip.all" },
        { id: "open", name: "equip.open" },
        { id: "partially_returned", name: "equip.partially_returned" },
        { id: "returned", name: "equip.returned" },
        { id: "closed", name: "equip.closed" },
    ];

    return (
        <Box sx={{ mb: 2, width: 280 }}>
            <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>{translate("equip.state")}</InputLabel>
                <Select
                    value={value}
                    label={translate("equip.state")}
                    title={translate("equip.state")}
                    onChange={(e) => onChange(e.target.value)}
                >
                    {stateChoices.map((choice) => (
                        <MenuItem key={choice.id} value={choice.id}>
                            {translate(choice.name)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};
